'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
function $ct_jl_Enum__T__I__($thiz, _name, _ordinal) {
  $thiz.q = _name;
  $thiz.M = _ordinal;
  return $thiz;
}
export { $ct_jl_Enum__T__I__ as $ct_jl_Enum__T__I__ };
/** @constructor */
function $c_jl_Enum() {
  this.q = null;
  this.M = 0;
}
export { $c_jl_Enum as $c_jl_Enum };
$p = $c_jl_Enum.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_jl_Enum;
/** @constructor */
function $h_jl_Enum() {
}
export { $h_jl_Enum as $h_jl_Enum };
$h_jl_Enum.prototype = $p;
$p.b = (function() {
  return this.q;
});
$p.f = (function(that) {
  return (this === that);
});
$p.m = (function() {
  return $j_java$002elang$002e$002dObject.$systemIdentityHashCode(this);
});
$p.Ok = (function(o) {
  var x = this.M;
  var y = o.M;
  return ((x === y) ? 0 : ((x < y) ? (-1) : 1));
});
$p.fh = (function(o) {
  return this.Ok(o);
});
